import { Component, OnInit, TemplateRef, Input, Output, EventEmitter, Inject } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { GlobalConstants } from '../../services/global-variables';
import { ApiService } from '../../services/api.service';
// import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthenticationService } from '../../services/authentication.service';
import { AubGTMTrackingService } from '../../services/aub-gtm-tracking.service';
import { AubTrackingService } from '../../services/aub-tracking.service';
import { ToastrService } from 'ngx-toastr';
import { BrowserStorageService } from 'src/app/services/browser-storage.service';
import { ModalWrapperService } from 'src/app/ui-components/modal-wrapper/modal-wrapper.service';
import { Subject, Subscription } from 'rxjs';
import { CardSwitchComponent } from '../card-switch/card-switch.component';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss'],
  providers: [GlobalConstants]
})
export class AuthenticationComponent implements OnInit {
  @Input() showAuthentication: boolean = false;
  @Output() reloadHeader = new EventEmitter();
  @Output() closeAuthenticationEvent:Subject<any> = new Subject<any>();
  IDLE_TIMEOUT = 900;
  _idleSecondsTimer = null;
  _idleSecondsCounter = 0;
  showLoggedOut: boolean = false;
  stepToShow: string | null = '';
  client: any;
  // modalRef: BsModalRef;
  allCountries: any = [];
  selectedCountry: any;
  isCountryDropdownOpen: any;
  userAuthMode: any;
  showStepZero: boolean = false;
  cardSwitchComponentInstance:NgbModalRef = {} as NgbModalRef;
  cardSwitchComponentSubscription:Subscription = {} as Subscription;
  ifExistingUser: boolean = true;
  showIfNotAuthenticated: boolean = false;
  invalidUser: boolean = false;
  userSearching: boolean = false;
  errorRequestingOtp: boolean = false;
  invalidOtp: boolean = false;
  validOtp: boolean = false;
  invalidCard: boolean = false;
  userId: any;
  urlcode: any;
  uid: any;
  apiclient: any;
  otpInp: any;
  authenticated_user: boolean = false;
  mobileInputBtnActive: any = false;
  emailPattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
  createWithUserForm: any = this.fb.group({
    mobile: ['', [Validators.required]],
    email: ['']
  });
  get f() { return this.createWithUserForm.controls; }
  mobNum: any;
  validateUserOtpForm: any = this.fb.group({
    userId: [''],
    otp: [''],
  });
  addCardForm: any = this.fb.group({
    binFirst4: [''],
    binLast4: ['']
  });

  isload1: boolean = false;
  isload2: boolean = false;
  loginProgress: boolean = false;
  timer: any = 'initial';
  viewTimer: any = 0;
  timerToShow: any;
  userStatus: any = "login";
  userCards: any = [];
  binError: boolean = false;
  binInvalid: boolean = false;
  cardVerified: boolean = false;
  submittedForm1: boolean = false;
  errorRequestingOtpMsg: string = '';
  ref_no: any;
  searchLoader: boolean = false;
  reloaded: boolean = false;
  otpVerifying: boolean = false;
  showNoCards: boolean = false;
  showNoCardsMessage: any = "";
  fetchingCard: boolean = false;
  loginEventValidatingCard: boolean = false;
  cardNum: any;
  processedToken = false;
  featuredCountryCodes = ['IND', 'SGP', 'ARE', 'AUS', 'USA', 'GBR'];
  popularCountries:any[] = [];
  otherCountries:any[] = [];

  currentStep = 0;
  showNtbUser = false;
  cancelableAuth = false;
  customer_type: any;
  returnUrl: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _apiService: ApiService,
    private fb: FormBuilder,
    private _auth: AuthenticationService,
    public GlobalConstants: GlobalConstants,
    private modalRef : ModalWrapperService,
    private _aub_gtm_ts: AubGTMTrackingService,
    private _aubts: AubTrackingService,
    private toastr: ToastrService,
    private browserStore: BrowserStorageService
  ) {

    if (this.browserStore.get("firstLoad") && !this.browserStore.get("currentUser")) {
      this.removeLocalStorage();
    }


    let auparams = JSON.parse(this.browserStore.get('auparams', 'session'));
    if (auparams && auparams.tk) {
      this.browserStore.remove('auparams', 'session');
      this.processDataQuery(auparams);
    }

    this.route.queryParams.subscribe((params: any) => {
      if (params.code) {
        this.urlcode = params.code;
      }
      else if (params.data) {
        this.urlcode = params.data;
        // this.urlcode = 'cKG3tlZT+OB3R4X60H60obFPbWCWcegdboFgUU1CNo1IgYgDq4vh3mCzBDppW/aDHynMvuIailvvQPExCS3ZGilNQxctAtxCedy2RUH+ThlCY42Jl7lWtAp/FwF9YKtaojshX2lyaQ047vxQsTHwQhZzMlg6SYVNgdajTXqLr89roh5//ChPsJ36v63v6FMuLw9+VG9RCBMizbI4Ta2JRMpeuWH/B6j2YXbDYaUNf6Kw5069IVvfoQzOWgV8QGCeyiiR7V/aDqlnSOhdGN9qD/VBa1LWey62to2aubiaN4sGJ1+lQlJ/EsMHpDlzmLSnpC2/uG9uje0VXAm/VEyqDnQtKR/OmM7ltOioTGQRszuJm30/lNbku4SUhsAeuuhxwqC5UfxOemfo1ZZ4sZ3L/g2frQGCP9dZW3KIVShW5eYJi/bek6tjxCaJa9snMF1dn9xmwReUVJFhPFi81bjdyY78vkais5lHVjomKm87+V+ulucjY0nxLSIWbVoZ9h6C1bZiJc+TFL5Ot8fMm5iw2S+nGKjoNfnlUH9zkAEhytfWvhH1vmktM3QcnGhQV6xBZvAjHv6unr57ng/Ct/nqHt3S82bWi8wRhUldS9JdNH4WcK1iO0d7Y2WzTYKuuxTuOaJ70bJJaXoir9Q9sV/YItRH6BUHEKucawtfrPqhks1r1iwL/hbFFl83Besb2qme9V1QbHqWQlLBetxDDBgP3DRSUGAJyRXJRkG5koMuuK0AK20bXa89X20JytSdDT4mDuqyRcNZkp9SoEqbhErx3GR0sWaZ1vjB2nXeqOSTzpK27OmZAha8Nn8mYiRriZlJsxtDhDVhMzXCxtDvv4RMocmJihMuHmgf0DmozvNSj/I9I59pyB7RxY2V8szGF5yWlP9LTctPAQAfzqGs4uBHN/JVT03PsTRJp1VmA4UWrB5wnrbahYpcpomNMjS/blegT+sfjZURye/LRGwjJcZxe6cG8A/q95LQ+Y4I5o4jA04Es2RppzEf/5tXmR80GFWWCZp9kbmX+aY4WVmzPNduzo6Im0YweCvGb1kPLUu+UJyywjtNVGkUvzRM4Qj4dPlgpMyjCRFwyO4Gn/F8i8lud6W1X8at5PfcMPP3/tCwpGoT9yjId3pTYB9snjsICwgb';
        // router.navigate([], { queryParams: { code: null }, queryParamsHandling: 'merge' })
        // let qParams: Params = ;
        this.setQueryParams({} as Params)
      }
      else if (params.tk) {
        this.removeLocalStorage();
        if (atob(params.tk) != 'no-token') {
          this.urlcode = atob(params.tk);
          this.processedToken = true;
        }
        if (params.ru) {
          let returnUrl = JSON.stringify(atob(params.ru).trim());
          this.browserStore.set('returnUrl', returnUrl);
        }
        if (params.cf) {
          let channel_ref = params.cf.toLowerCase();
          this.browserStore.set('channel_ref', channel_ref);
          if (channel_ref == 'mb') {
            this.browserStore.set('appUser', 'true');
          }
        }
        if (params.ct) {
          let customer_type = atob(params.ct).toLowerCase();
          this.browserStore.set('customer_type', customer_type.toLowerCase());

          this.setQueryParams({} as Params)
          if (customer_type && customer_type != 'etb') {
            this.browserStore.set('skipReloadLogout', 'true', 'session');
            this.reloadInit();
            this.loginProgress = false;
            this.browserStore.set('urlcode', 'no-token');
            return ;
          }
        }
      }
      else if (params.token) {
        this.removeLocalStorage();
      }
    });
    if (this.urlcode) {
      this.loginProgress = true;
      if (!this.processedToken) {
        this.processUrlToken();
      }
      else {
        this.processEncodedUrlToken();
      }
    } else if (this.browserStore.get("currentUser")) {
      let current_user = JSON.parse(this.browserStore.get("currentUser"));
      this.authenticated_user = true;
    }
    else {
      this.authenticated_user = false;
      if (this.GlobalConstants.data.personalized_config.force_auth || this.showAuthentication) {
        this.restartLogin();
      }
    }

    this._auth.errorEvent.subscribe((res) => {
      if (res) {
        let customer_type = this.browserStore.get('customer_type');
        
        if (customer_type) {
          if (customer_type.toLowerCase() === 'ntb' || customer_type.toLowerCase() === 'noetb' || customer_type.toLowerCase() === 'ntb-logout') {
            this.customer_type = customer_type.toLowerCase();
            this.returnUrl = this.browserStore.get('returnUrl') ? JSON.parse(this.browserStore.get('returnUrl')) : null;
            this.showNtbUser = true;
          }

        }
        else if (this.browserStore.get('returnUrl')) {
          const returnUrl = JSON.parse(this.browserStore.get('returnUrl'));

        }
        else if (this.browserStore.get('diningSearchParams')) {
          const diningSearchParams = this.browserStore.get('diningSearchParams');
          this.browserStore.clearAll();
          this.browserStore.set("diningSearchParams", diningSearchParams);
          this.restartLogin(true);
          // location.replace(returnUrl);
        }
        else {
          this.restartLogin();
        }
      }
    })
    this._auth.reloadInit.subscribe((res) => {
      if (res) {
        this.reloadInit();
      }
    })
  }
  processDataQuery(params: any): void {
    this.removeLocalStorage();
    if (params.tk != 'no-token') {
      this.urlcode = params.tk;
      this.processedToken = true;
    }
    if (params.ru) {
      let returnUrl = JSON.stringify(params.ru.trim());
      this.browserStore.set('returnUrl', returnUrl);
    }
    if (params.cf) {
      let channel_ref = params.cf.toLowerCase();
      this.browserStore.set('channel_ref', channel_ref);
      if (channel_ref == 'mb') {
        this.browserStore.set('appUser', 'true');
      }
    }
    if (params.ct) {
      let customer_type = params.ct.toLowerCase();
      this.browserStore.set('customer_type', customer_type.toLowerCase());

      if (customer_type && customer_type != 'etb') {
        this.loginProgress = false;
        this.browserStore.set('urlcode', 'no-token');
        this.router.navigate(['/']);
        return;
      }
    }
  }
  setQueryParams(qParams: Params) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: qParams,
      queryParamsHandling: ''
    });
  }
  removeLocalStorage() {

    this.browserStore.remove('currentUser');
    this.browserStore.remove('card_verified');
    this.browserStore.remove('returnUrl');
    this.browserStore.remove('customer_type');
    this.browserStore.remove('channel_ref');
    this.browserStore.remove('userCards');
    this.browserStore.remove('cardSelected');
    this.browserStore.remove('userCard');
  }
  processEncodedUrlToken(urlcode?: any) {
    if (this.urlcode) {
      this.urlcode = this.urlcode;
    }
    this.browserStore.remove('currentUser');
    this.browserStore.remove('card_verified');
    if (this.GlobalConstants.data.personalized_config.show_card_select_on_auth && this.browserStore.get("customer_type") && this.browserStore.get("customer_type") == 'etb') {
      this.browserStore.set('card_verified', "true");
      this.browserStore.set('urlcode', this.urlcode);
      let user: any = {
        token: this.urlcode,
        skipExceptCard: true
      }
      this.browserStore.set('currentUser', JSON.stringify(user));
      this._apiService.getUserDetails().subscribe(
        (res: any) => {
          this.fetchingCard = true;
          user['id'] = res.id;
          this.browserStore.set('currentUser', JSON.stringify(user));
          this.fetchCards();
        },
        (err) => {
          this.loginProgress = false;
          this.removeLocalStorage();
          this.router.navigate(['/']);
        }
      );
    }
    else {
      this.loginProgress = false;
    }
  }
  processUrlToken() {
    this.browserStore.remove('currentUser');
    this.browserStore.remove('card_verified');
    this._apiService.createTokenUser(this.urlcode, this.uid || null, this.apiclient || null).subscribe(
      (res: any) => {
        if (res.token) {
          let user = {
            token: res.token
          }

          if (res.req_data && res.req_data.return_url) {
            this.browserStore.set('returnUrl', JSON.stringify(res.req_data.return_url));
          }
          if (res.req_data && res.req_data.customer_type) {
            this.browserStore.set('customer_type', res.req_data.customer_type);
          }
          else {
            this.browserStore.set('customer_type', 'etb');
          }


          if (user && user.token) {
            this.browserStore.set('currentUser', JSON.stringify(user));
            this.browserStore.set('card_verified', "true");
            this.browserStore.set('urlcode', this.urlcode);
            this.fetchingCard = true;
            this._apiService.getUserDetails().subscribe(
              (res: any) => {
                this.fetchingCard = true;
                if (this.GlobalConstants.data.personalized_config.show_card_select_on_auth) {
                  if (this.browserStore.get("customer_type") && this.browserStore.get("customer_type") != 'ntb') {
                    this.fetchCards();
                  }
                  else {
                    this.loginProgress = false;
                    this.browserStore.remove('currentUser');
                    this.browserStore.remove('card_verified');
                  }
                }
                else {
                  this._apiService.getCards().subscribe((response) => {
                    this.fetchingCard = false;
                    if (response && response.data && response.data.length > 0) {
                      let card = response.data[0];
                      this.browserStore.set('userCard', JSON.stringify(card));
                      this.browserStore.set('userCards', JSON.stringify(response.data));
                      this.authReload();
                      // this.router.navigate([], { queryParams: { code: null }, queryParamsHandling: 'merge' })
                      // window.location.href = "/";
                      setTimeout(() => { this.loginProgress = false; }, 1000);
                    }
                    else {
                      window.location.href = "/";
                    }
                  });
                }
              });


          }
        }
        else if (res.req_data && res.req_data.customer_type) {
          this.browserStore.set('customer_type', res.req_data.customer_type);
        }
      },
      (err) => {
        this.showIfNotAuthenticated = true
      }
    );
  }
  fetchCards() {
    if (this.browserStore.get("customer_type") == 'etb') {
      this._apiService.fetchCards().subscribe((response) => {
        this.fetchingCard = false;
        if (response && response.data && response.data.length > 0) {
          this.browserStore.set("userCards", JSON.stringify(response.data));
          this.loginProgress = false;
          if (response.data.length > 1) {
            this.loginProgress = false;
            this.cardSwitchComponentInstance = this.modalRef.open(CardSwitchComponent,'switch-card-modal',true);
            this.cardSwitchComponentInstance.componentInstance.emitCloseSwitchPanelEvent.subscribe((res:string)=>{
              console.log(res,'>>> res');
              this.closeAuthenticationEvent.next('card-selected');
              this.cardSwitchComponentInstance.close();
            });
          } else {
            this.checkIfBinValid(response.data[0].attributes.bin, response.data[0].attributes.bin_type, response.data[0].id);
          }
        }
        else {
          this.browserStore.remove('currentUser');
          this.browserStore.remove('card_verified');
          this.browserStore.remove('userCards');
          this.loginProgress = false;
          this.fetchingCard = false;
          if (this.browserStore.get("customer_type") && this.browserStore.get("customer_type") == 'etb') {
            this.browserStore.set("customer_type", "noetb");
            this.reloadInit();
          }
          else {
            this.toastr.error('', 'Error! No card found', {
              timeOut: 10000
            });
          }

        }
      },
        (err: any) => {
          this.loginProgress = false;
          this.fetchingCard = false;
          this.browserStore.clearAll();
        });
    }
    else {
      this.loginProgress = false;
      this.browserStore.remove('currentUser');
      this.browserStore.remove('card_verified');
    }

  }
  ngOnInit() {
    this.currentStep = 0;
    this.stepToShow = this.GlobalConstants.data.login_steps[0];

    let card_verified = this.browserStore.get('card_verified');
    if (!card_verified || card_verified == "false") {
      this.browserStore.remove('currentUser');
      this.cardVerified = false;
    }
    else {
      this.cardVerified = true;
    }

    // if (sessionStorage.getItem('client')) {
    //   this.client = JSON.parse(sessionStorage.getItem('client'));
    // } else {
    //   this.getClient();
    // }

    if (this.browserStore.get("currentUser")) {
      let current_user = JSON.parse(this.browserStore.get("currentUser"));
      this._aubts.aubts_poshvine_login(current_user.mobile);
      this._aub_gtm_ts.aubts_gtm_Login_loggedin();
      if (!this.ifExistingUser) {
        this._aub_gtm_ts.aubts_gtm_offers_Login_first_registration();
      } else {
        this.gtmLogin(current_user.id, "Existing user");
      }
    }
    else{
      this._aub_gtm_ts.aubts_login_modal_open();
    }
  }

  gtmLogin(userid: any, usertype: any) {
    this._aub_gtm_ts.pushToDataLayer({
      "event": "Login",
      "UserID": userid,
      "usertype": usertype
    });
  }

  doLater() {

    this.showIfNotAuthenticated = false;
    this.customer_type = 'noetb'
    this.browserStore.set("customer_type", "noetb");
    this.showNtbUser = true;
  }

  gtmForm() {
    this._aub_gtm_ts.pushToDataLayer({
      'event': 'offers_Login_mobile-number',
      'EventCategory': 'Offers Login',
      'EventAction': 'Mobile Number',
      'EventLabel': 'Continue',
      'url': '/vpv/offers/login/mobile-number'
    });
  }

  gtmMobileMismatch() {
    this._aub_gtm_ts.pushToDataLayer({
      'event': 'offers_Login_mobile-number-error',
      'EventCategory': 'Offers Login',
      'EventAction': 'Mobile Number',
      'EventLabel': 'Error',
      'url': '/vpv/offers/login/mobile-number'
    });
  }

  gtmOtpSuccess() {
    this._aub_gtm_ts.pushToDataLayer({
      'event': 'offers_Login_mobile-num_OTP-success',
      'EventCategory': 'Offers Login',
      'EventAction': 'Mobile OTP',
      'EventLabel': 'Success',
      'url': '/vpv/offers/login/mobile-number/OTPsuccess'
    });
  }

  gtmOtpError() {
    this._aub_gtm_ts.pushToDataLayer({
      'event': 'offers_Login_mobile-num_OTP-error',
      'EventCategory': 'Offers Login',
      'EventAction': 'Mobile OTP',
      'EventLabel': 'Error',
      'url': '/vpv/offers/login/mobile-number/OTPerror'
    });
  }

  gtmRandomClose() {
    this._aub_gtm_ts.pushToDataLayer({
      'event': 'offers_Login_dropping',
      'EventCategory': 'Offers Login',
      'EventAction': 'Cancelled Login',
      'EventLabel': 'Close Button',
      'url': '/vpv/offers/login/dropping'
    });
  }

  session_closed_tryagain() {
    this._aub_gtm_ts.aubts_gtm_login_session_closed_tryagain();
  }


  reloadInit() {
    this.browserStore.set('skipReloadLogout', 'true', 'session');
    this.loginProgress = false;
    this.ngOnInit();
    this.reloadHeader.emit();
    this.closeAuthenticationEvent.next('success');
  }

  removeLetter(eve :any) {
    let str = ''
    if(eve && eve.target && eve.target.value){
      str = eve.target.value;
    }
    this.createWithUserForm.controls['mobile'].setValue(str.replace(/\D/g, ""));
  }
  getClient() {
    this._apiService.getClient(true).subscribe(
      (res: any) => {
        this.client = res;
        this.userAuthMode = this.client.user_auth_mode;
        this.browserStore.set('client', JSON.stringify(this.client), 'session');
      },
      (err) => {
      }
    );
  }

  userSearch() {

    this.isload1 = false;
    this.errorRequestingOtpMsg = "";
    this.userId = "";
    this.ifExistingUser = true;
    if (this.selectedCountry && this.createWithUserForm.value.mobile.length > (this.selectedCountry.min_mobile_digit - 1) && this.createWithUserForm.value.mobile.length < (this.selectedCountry.max_mobile_digit + 1)) {
      this.mobileInputBtnActive = true;
      if (this.GlobalConstants.data.personalized_config.allow_user_create) {
        this.searchLoader = true;
        this.userSearching = true;
        this._auth.validateExistingUser(this.createWithUserForm.value.mobile, this.cardNum).subscribe((response) => {
          this.userSearching = false;
          this.searchLoader = false;
          if (response && response.mobile == this.createWithUserForm.value.mobile) {
            this.ifExistingUser = true;
            this.userId = response.id;

            if (this.GlobalConstants.data.login_theme == 2) {
              this.cardVerified = true;
              this.browserStore.set('card_verified', "true");
            }
          } else {
            if (this.GlobalConstants.data.personalized_config.external_otp) {
              this.ifExistingUser = true;
              this.userId = response.id;
            } else {
              this.ifExistingUser = false;
              this.userId = "";
              this.createWithUserForm.controls['email'].setValidators([Validators.pattern(this.emailPattern)])
              this.createWithUserForm.controls['email'].updateValueAndValidity();
            }
          }
        })
      }
    }
    else {
      this.mobileInputBtnActive = false;
    }
  }

  closeAuthentication() {
    const diningSearchParams = this.browserStore.get('diningSearchParams');
    this.browserStore.clear();
    this.browserStore.clear('session');
    this.browserStore.set("diningSearchParams", diningSearchParams);
    this.showIfNotAuthenticated = false;
    this.closeAuthenticationEvent.next('close-modal')
  }

  showMergedOtp: boolean = false;
  authenticateUser(event: any, goTonextStep = true): void {
    this.isload1 = true;
    this.errorRequestingOtpMsg = "";
    this.submittedForm1 = true;
    // event.preventDefault();
    if (this.userSearching) {
      this.isload1 = false;
      return;
    }
    this.gtmForm();
    if (this.createWithUserForm.valid) {
      if (this.GlobalConstants.data.personalized_config.external_otp) {
        this.requestExternalOtp(goTonextStep);
      } else {
        if (this.ifExistingUser && this.userId != "" && this.userId != undefined) {
          this.requestPoshvineOtp(goTonextStep);
        }
        else if (!this.GlobalConstants.data.personalized_config.allow_user_create && (this.createWithUserForm.value.mobile.length > (this.selectedCountry.min_mobile_digit - 1) && this.createWithUserForm.value.mobile.length < (this.selectedCountry.max_mobile_digit + 1))) {
          this.searchLoader = true;
          this.userSearching = true;
          this._auth.validateExistingUser(this.createWithUserForm.value.mobile, this.cardNum).subscribe((response) => {
            this.userSearching = false;
            this.searchLoader = false;
            this.isload1 = false;
            if (response && response.mobile == this.createWithUserForm.value.mobile) {
              this.ifExistingUser = true;
              this.userId = response.id;
              if (this.GlobalConstants.data.personalized_config.external_otp) {
                this.requestExternalOtp(goTonextStep);
              }
              else {
                this.requestPoshvineOtp(goTonextStep);
              }
            }
            else {
              this.mobileInputBtnActive = false;
              this.isload1 = false;
              this.ifExistingUser = false;
              this.userSearching = false;
              this.searchLoader = false;
            }
          })

        }
        else if (this.GlobalConstants.data.personalized_config.allow_user_create) {
          this.createUser();
        } else {
          return;
        }

      }
    }
  }
  handleOtpError(message: string) {
    this.errorRequestingOtpMsg = message;
    this.errorRequestingOtp = true;
    this.submittedForm1 = false;
  }
  requestPoshvineOtp(goTonextStep = true) {

    this._auth.requestUserOtp(this.createWithUserForm.value.mobile, this.userId).subscribe((response) => {
      if (response) {
        this.submittedForm1 = false;
        this.countDown(180, () => {
          this.timer = 'complete';
        });
        setTimeout(() => {
          this.showStepZero = false;
          this.isload1 = false;
          if (goTonextStep) {
            this.currentStep = this.currentStep + 1;
            this.stepToShow = this.GlobalConstants.data.login_steps[this.currentStep];
          }
        }, 1000);
        setTimeout(() => {    //<<<---    using ()=> syntax
          const elem = document.getElementById("otp-field");
          if (elem) {
            elem.focus()
          }
        }, 1800);
      } else {
        this.handleOtpError('OTP Request limit exceeded. Please try after 30 mins.');
      }
    }, (error) => {
      this.handleOtpError('OTP Request limit exceeded. Please try after 30 mins.');
    })
  }
  requestExternalOtp(goTonextStep = true) {
    this._auth.externalRequestUserOtp(this.createWithUserForm.value.mobile).subscribe((response) => {
      if (response) {
        this.ref_no = response.ref_no;
        this.submittedForm1 = false;
        this.countDown(180, () => {
          this.timer = 'complete';
        });
        setTimeout(() => {    //<<<---    using ()=> syntax
          this.showStepZero = false;
          this.isload1 = false;
          if (goTonextStep) {
            this.currentStep = this.currentStep + 1;
            this.stepToShow = this.GlobalConstants.data.login_steps[this.currentStep];
          }
        }, 1000);
        setTimeout(() => {    //<<<---    using ()=> syntax
          let elem = document.getElementById("otp-field");
          if (elem) {
            elem?.focus();
          }
        }, 1800);

      } else {
        this.handleOtpError('Could not generate OTP, Please try again');
      }
    }, error => {
      this.handleOtpError('Dear Customer, please check if your mobile number is registered with us');
      this.isload1 = false;
    })
  }
  createUser() {
    this.gtmMobileMismatch();
    this._auth.createUser(this.createWithUserForm.value.mobile, this.createWithUserForm.value.email, this.selectedCountry?.calling_codes[0]).subscribe((response) => {

      if (response && response.id) {
        this.showStepZero = false;
        this.currentStep = this.currentStep + 1;
        this.stepToShow = this.GlobalConstants.data.login_steps[this.currentStep];
        this.submittedForm1 = false;
        this.countDown(180, () => {
          this.timer = 'complete';
        });

        setTimeout(() => {    //<<<---    using ()=> syntax
          let elem = document.getElementById("otp-field")
          if (elem) {
            elem.focus();
          }
        }, 1000);
        this.userId = response.id;
        this.userStatus = "activation";
      } else {
        this.invalidUser = true;
        this.submittedForm1 = false;
      }
    }, error => {
      this.isload1 = false;
      this.handleOtpError(
        (error.error) ?
          error.error.errors.join(", ") : "Please check your eligibility."
      );
    })
  }
  validateUserOtp() {
    if (this.otpInp && this.otpInp.length == 6) {
      this.otpVerifying = true;
      if (this.GlobalConstants.data.personalized_config.external_otp) {
        this._auth.externalValidateUserOtp(this.otpInp, this.ref_no, this.mobNum).subscribe((response) => {
          this.otpVerifying = false;
          if (response && response.token) {
            this.gtmOtpSuccess();
            this.showAuthentication = false;
            this.getUserCard();
            this.browserStore.set('card_verified', "true");
          } else {
            this.gtmOtpError();
            this.errorRequestingOtpMsg = "Entered Otp is invalid";
            this.errorRequestingOtp = true;
            this.submittedForm1 = false;
            this.isload2 = false;
          }
        }, error => {
          this.otpVerifying = false;

          this.handleOtpError('Dear Customer, please check if your mobile number is registered with us');
          this.isload2 = false;
          this.gtmOtpError();
        })
      } else {
        this._auth.validateUserOtp(this.userId, this.otpInp, this.userStatus, this.mobNum).subscribe((response) => {
          this.otpVerifying = false;
          if (response && response.token) {
            this.gtmOtpSuccess();
            this.stepToShow = null;
            this.validOtp = true;
            if (this.GlobalConstants.data.loginAt == 'otp') {
              this.getUserCard();
            }
            else if (this.GlobalConstants.data.personalized_config.has_card == true) {
              this.loginEventValidatingCard = true;
              this.currentStep = this.currentStep + 1;
              this.stepToShow = this.GlobalConstants.data.login_steps[this.currentStep];
              // this.checkIfBinValid();
              this.closeAuthenticationEvent.next('success');
            }
            else {
              this.showIfNotAuthenticated = false;
              this.stepToShow = null;
              this.showAuthentication = false;
              this.reloadInit();
              this.closeAuthenticationEvent.next('success');
            }
          } else {
            this.gtmOtpError();
            this.invalidOtp = true;
            this.validOtp = false;
          }
        }, (error) => {
          this.otpVerifying = false;
          this.errorRequestingOtpMsg = "Please check the entered OTP";
          this.errorRequestingOtp = true;
          this.gtmOtpError();
          if (this.GlobalConstants.data.personalized_config.autocard_check) {
            this.stepToShow = null;
            this.showIfNotAuthenticated = false;
            this.showNoCards = true;
            this.showNoCardsMessage = this.GlobalConstants.data.content.autocard_check_card_error;
            this._aub_gtm_ts.aubts_gtm_login_session_closed();
          }
        })
      }
    }
  }

  getUserCard() {
    this.fetchingCard = true;
    this._apiService.getCards().subscribe((response) => {
      this.fetchingCard = false;
      if (response && response.data && (response.data.length > 0 || response.data.attributes)) {
        if (this.GlobalConstants.data.personalized_config.show_card_select_on_auth) {
          if (response.data.length > 1) {
            this.stepToShow = null;
            this.showIfNotAuthenticated = false;
            this.cardSwitchComponentInstance = this.modalRef.open(CardSwitchComponent,'switch-card-modal',true);
            this.cardSwitchComponentInstance.componentInstance.emitCloseSwitchPanelEvent.subscribe((res:string)=>{
              this.cardSwitchComponentInstance.close();
              this.closeAuthenticationEvent.next('success');
            });
          } else {
            this.checkIfBinValid(response.data[0].attributes.bin, response.data[0].attributes.bin_type, response.data[0].id);
          }
        }
        else {
          let thebin = this.browserStore.get('thebin');
          let currentCard: any;
          if (response.data.attributes) {
            currentCard[0] = response.data;
          }
          else {
            currentCard = response.data.filter((x: any) => x && x.attributes && x.attributes.bin == thebin);
          }
          let card;
          if (currentCard.length == 1) {
            card = JSON.stringify(currentCard[0]);
            this.browserStore.set('userCard', card);
            this.browserStore.set("userCards", JSON.stringify(response.data));
            if (this.GlobalConstants.data.loginAt == "otp") {
              this.checkIfBinValid(currentCard[0].attributes.bin, currentCard[0].attributes.bin_type);
            }
          }
          else {
            this.addCard(true, true);
          }
          this.stepToShow = null;
          if (!this.GlobalConstants.data.personalized_config.autocard_check) {
            this.stepToShow = 'card';
          }
          if (this.GlobalConstants.data.personalized_config.skip_card_if_exist) {
            this.cardVerified = true;
            this.browserStore.set('card_verified', "true");
          }
          if (this.userAuthMode == "preset_bin" || this.GlobalConstants.data.loginAt == "card" || this.GlobalConstants.data.loginAt == "otp") {
            if (this.cardVerified == true) {
              this.stepToShow = null;
              this.showIfNotAuthenticated = false;
              this.showAuthentication = false;
              this.reloadInit();
            } else {
              this.stepToShow = 'card';
              this.showIfNotAuthenticated = true;
              this.cardVerified = false;
              this.browserStore.set('card_verified', "false");
            }
          } else {
            this.showIfNotAuthenticated = false;
            if (this.GlobalConstants.data.loginAt == "otp") {
              // this.browserStore.remove('userCard');
              // this.browserStore.set('card_verified', "true");
              this.showAuthentication = false;
              // this.reloadInit();
            }
          }
        }
      } else {

        this.showIfNotAuthenticated = false;
        this.browserStore.remove('currentUser');
        this.browserStore.set('card_verified', "false");
        this.showNtbUser = true;
        this.customer_type = 'noetb'
        this.browserStore.set("customer_type", "noetb");
        this._aub_gtm_ts.aubts_gtm_login_session_closed();

        if (this.GlobalConstants.data.loginAt == 'external') {
          location.reload();
        }
      }



    });
  }

  addCard(reload = false, binCheck = false) {
    let thebin = this.browserStore.get('thebin');
    this._apiService.addCard(thebin, "first6").subscribe((response) => {
      if (response && response.data && response.data.attributes) {
        let card = JSON.stringify(response.data);
        this.browserStore.set('userCard', card);
        this.browserStore.set('card_verified', "true");
        this.showIfNotAuthenticated = false;
        this.stepToShow = null;
        if (binCheck) {
          this.checkIfBinValid(thebin, "first6");
        }
        else if (reload) {
          this.reloadInit();
        }
      }
    });
  }
  checkIfBinValid(bin: any, bin_type: any, card_id?: any) {
    if (card_id) {
      this._apiService.switchCard(card_id).subscribe(res => {
        if (res && res.data && res.data.attributes.bin == bin && res.data.attributes.status == 'bin_verified') {
          let current_user = JSON.parse(this.browserStore.get("currentUser"));
          current_user.token = res.data.attributes.session_token;
          if (current_user.skipExceptCard) {
            current_user.skipExceptCard = false;
          }
          this.browserStore.set('currentUser', JSON.stringify(current_user));
          this.browserStore.set('card_verified', "true");
          this.browserStore.set('userCard', JSON.stringify(res.data));
          this.cardVerified = true;

          this.showIfNotAuthenticated = false;
          this.binError = false;
          this.binInvalid = false;
          this.loginProgress = false;
          this.addLocation(true);
          this.browserStore.set('skipReloadLogout', 'true', 'session');
        }
        else {
          this.browserStore.set('card_verified', "false");
        }
      })
    }
    else {
      this._apiService.validateCard(bin, bin_type).subscribe(res => {
        this.isload2 = false;
        if (res && res.data && res.data.attributes.bin == bin && res.data.attributes.status == 'bin_verified') {
          let current_user = JSON.parse(this.browserStore.get("currentUser"));
          current_user.token = res.data.attributes.session_token;
          this.browserStore.set('currentUser', JSON.stringify(current_user));
          this.cardVerified = true;
          this.browserStore.set('card_verified', "true");
          this.browserStore.set('userCard', JSON.stringify(res.data));

          this.showIfNotAuthenticated = false;
          this.binError = false;
          this.binInvalid = false;
          this.loginProgress = false;
          this.addLocation(true);
        }
        else {
          this.loginProgress = false;
          this.binError = true;
          if (this.userAuthMode == "preset_bin") {
            this.browserStore.set('card_verified', "false");
          }
        }
      })
    }

  }

  authReload() {
    this.browserStore.set('skipReloadLogout', 'true', 'session');
    if (this.GlobalConstants.data.personalized_config.force_auth || this.urlcode) {
      window.location.href = "/";
    } else {
      this.reloadInit();
    }
  }
  addCardFormSubmit() {
    if (this.binError) {
      this._auth.logout();
      window.location.href = "/";
    }
    this.isload2 = true;
    let bin;
    bin = this.addCardForm.value.binFirst4.toString() + "_" + this.addCardForm.value.binLast4.toString();
    this.checkIfBinValid(bin, this.GlobalConstants.data.card_num_type);


  }


  getAllCountries() {
    console.log('get country')
    this._apiService.getAllCountries().subscribe((resp: any) => {
      if (resp && resp.data) {
        this.popularCountries = [];
        this.otherCountries = [];
        this.allCountries = resp.data;
        if (this.allCountries && this.allCountries.length > 0) {
          this.allCountries.forEach((obj: any) => {
            let mobile_length = obj.attributes.mobile_length.split('...');
            obj.attributes.min_mobile_digit = parseInt(mobile_length[0]);
            obj.attributes.max_mobile_digit = parseInt(mobile_length[1]);
            if (this.featuredCountryCodes.includes(obj.attributes.iso_code)) {
              this.popularCountries.push(obj);
            } else {
              this.otherCountries.push(obj);
            }
          })
          const country = this.allCountries.filter((x: any) => x && x.attributes && x.attributes.name == "India")

          if (country.length > 0) {
            this.selectedCountry = country[0].attributes;
            this.browserStore.set("locationData", JSON.stringify(this.selectedCountry));
          }
          else {
            this.selectedCountry = null;
          }

          // sort popular countries array w.r.t featured array
          this.popularCountries.sort((a: any, b: any) =>
            this.featuredCountryCodes.indexOf(a.attributes.iso_code) - this.featuredCountryCodes.indexOf(b.attributes.iso_code)
          );

          // alphabetically sort other countries
          this.otherCountries.sort((a: any, b: any) => {
            let textA = a.attributes.name.toUpperCase();
            let textB = b.attributes.name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
          });

        }
        else {
          this.selectedCountry = null;
        }
      }
    });
  }

  setCountry(country: any) {
    this.isCountryDropdownOpen = false;
    this.selectedCountry = country.attributes;
    this.browserStore.set("locationData", JSON.stringify(this.selectedCountry));
  }
  onKeyph(e: any) {
    this.binError = false;
    this.binInvalid = false;
    e.target.value = e.target.value.replace(/[^\d]/g, '').trim();
  }
  keytab(event: any, el: any) {
    this.binError = false;
    this.binInvalid = false;
    this.isload2 = false;
    if (event.currentTarget.value.length == 4) {
      // document.getElementById('last_four_card_digits').focus();
      el.focus();
    }
  }
  btnActive: boolean = false;

  resetLoginAgain() {
    this.submittedForm1 = false;
    this.fetchingCard = false;
    this.searchLoader = false;
    this.isload1 = false;
    this.isload2 = false;
    this.stepToShow = this.GlobalConstants.data.login_steps[0];
    this.currentStep = 0;
    this.mobNum = undefined;
    this.mobileInputBtnActive = false;
    this.errorRequestingOtp = false;
    this.errorRequestingOtpMsg = "";

    if (this.createWithUserForm.controls) {
      if (this.createWithUserForm.controls['mobile']) {
        this.createWithUserForm.controls['mobile'].setValue("");
      }
      if (this.createWithUserForm.controls['otp']) {
        this.createWithUserForm.controls['otp'].setValue("");
      }
    }
    this.otpInp = '';
    this.showIfNotAuthenticated = true;
    this.userSearching = false;
    this.validOtp = false;
    (clearInterval(this.int), function () { });
  }
  cardValidation(bin: any) {
    this._apiService.cardValidation(bin).subscribe(res => {
      this.isload2 = false;
      if (res && res.success) {
        this.cardVerified = true;
        this.browserStore.set('card_verified', "true");
        this.currentStep = this.currentStep + 1;
        if (this.GlobalConstants.data.login_steps[this.currentStep]) {
          this.stepToShow = this.GlobalConstants.data.login_steps[this.currentStep];
        }
        else {
          this.stepToShow = null;
        }
        this.binError = false;
        this.binInvalid = false;
      } else {
        this.binError = true;
        if (this.userAuthMode == "preset_bin") {
          this.browserStore.set('card_verified', "false");
        }
      }
    })
  }
  checkbtn() {

    if ((this.addCardForm.value.binFirst4.length + this.addCardForm.value.binLast4.length) == 8) {

      // var bin = this.addCardForm.value.binFirst4.toString() + "_" + this.addCardForm.value.binLast4.toString();
      // this.checkIfBinValid(bin, 'first4_last4');

      this.btnActive = true;
    }
    else {
      this.btnActive = false;
    }

  }

  backkeytab(event: any) {
    this.binError = false;
    this.binInvalid = false;
    this.isload2 = false;

    if (event.currentTarget.value.length == 0 && event.key == 'Backspace') {
      let elem = document.getElementById('first_four_card_digits');
      if (elem) {
        elem.focus();
      }
    }

  }

  int: any;
  countDown(i: number, callback: any) {

    callback = callback || function () { };
    this.int = setInterval(() => {
      this.timer = 'started';
      this.viewTimer = i;
      const minutes: number = Math.floor(i / 60);
      this.timerToShow = minutes + ':' + (i - minutes * 60).toString().padStart(2, '0');

      i-- || (clearInterval(this.int), callback());
    }, 1000);
  }

  resetCountDown(i: number, callback: () => void) {

    callback = callback || function () { };
    var int = setInterval(() => {
      this.timer = 'started';
      this.viewTimer = i;
      const minutes: number = Math.floor(i / 60);
      this.timerToShow = minutes + ':' + (i - minutes * 60).toString().padStart(2, '0');

      i-- || (clearInterval(int), callback());
    }, 1000);
  }

  restartLogin(skipLogout = false) {
    if (!skipLogout) {
      this._auth.logout();
    }

    if (!this.allCountries || this.allCountries.length == 0) {
      this.getAllCountries();
    }
    this.currentStep = 0;
    this.stepToShow = this.GlobalConstants.data.login_steps[0];
    this.showIfNotAuthenticated = true;

    this.userSearching = false;
    this.validOtp = false;
    this.createWithUserForm.patchValue({ mobile: '' });
    this.createWithUserForm.patchValue({ email: '' });
    this.otpInp = '';
    this.addCardForm.patchValue({ binFirst4: '' });
    this.addCardForm.patchValue({ binLast4: '' });

  }

  clearOtp() {
    let elem = document.getElementById("otp-field");
    if (elem) {
      elem.focus();
    }
    this.otpInp = '';
  }

  goToLogin() {
    location.reload();
  }

  addLocation(shouldReload: boolean) {
    let userLocation = JSON.parse(this.browserStore.get("userLocation"));
    if (userLocation && userLocation.country && userLocation.country.id) {
      let params: any = {
        country_id: userLocation.country.id,
      }
      if (userLocation.state && userLocation.state.id) {
        params['city_id'] = userLocation.state.id;
      }
      this.closeAuthenticationEvent.next('success');
      this._apiService.addLocation(params).subscribe((res: any) => {
        if (shouldReload) {
          this.authReload();
        }

      });
    }
    else {
      if (shouldReload) {
        this.authReload();
      }
    }
  }
  theme2loginSetings = {
    showCardInput: false,
    showOtp: false
  }
  mobileLengthCheck(lengthToCheck: any) {
    this.theme2loginSetings.showCardInput = (this.mobNum.length == lengthToCheck);
  }
  reloadPage(){
    this.showNtbUser = false;
    this.browserStore.set('skipReloadLogout', 'true', 'session');
    location.reload();
  }
}
